import { useEffect, useState, useRef } from "react";
import Aos from "../../components/aos/aos";
const Summary = () => {
    const [afterAos, setAfterAos] = useState(false);
    const [count, setCount] = useState(0);
    const elementRef = useRef(null)
    useEffect(() => {
        Aos(1000)
    })
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setAfterAos(!afterAos);
                    
                    const timeout = setInterval(() => {
                        setCount((prevCount) => prevCount + 1)
                    }, 1)
                    
                    return () => clearTimeout(timeout);
                } else if (!entry.isIntersecting) {
                    setAfterAos(!afterAos);
                   
                    setCount(0)
                    
                }
            })
        })
        observer.observe(elementRef.current)
        return () => {
            observer.disconnect()
        }
    }, [])
    
    return (
        <div data-aos="fade-up" ref={elementRef} className="mt-8 bg-white/30 backdrop-blur w-full grid grid-cols-2 md:grid-cols-4 gap-x-4 place-content-center place-items-center gap-y-4 py-4 px-4 shadow-yellow-200 rounded-lg">
            <div className="w-[150px] h-[150px] px-2 py-2 rounded-full shadow-lg shadow-gray-400 flex flex-col justify-center items-center">
                <div className="text-2xl font-extrabold text-yellow-500"><span>{count < 50 ? count : 50}</span>+</div>
                <div className="text-md font-semibold text-black text-center">Clients</div>
            </div>
            <div className="w-[150px] h-[150px] px-2 py-2 rounded-full shadow-lg shadow-gray-400 flex flex-col justify-center items-center">
                <div className="text-2xl font-extrabold text-yellow-500"><span>{count < 3 ? count : 3}</span>+</div>
                <div className="text-md font-semibold text-black text-center">Years of experience</div>
            </div>
            <div className="w-[150px] h-[150px] px-2 py-2 rounded-full shadow-lg shadow-gray-400 flex flex-col justify-center items-center">
                <div className="text-2xl font-extrabold text-yellow-500"><span>{count < 100 ? count : 100}</span>%</div>
                <div className="text-md font-semibold text-black text-center">Fast Growing Start-up</div>
            </div>
            <div className="w-[150px] h-[150px] px-2 py-2 rounded-full shadow-lg shadow-gray-400 flex flex-col justify-center items-center">
                <div className="text-2xl font-extrabold text-yellow-500"><span>{count < 70 ? count : 70}</span>+</div>
                <div className="text-md font-semibold text-black text-center">Completed Projects</div>
            </div>

        </div>
    );
}

export default Summary;